// Interprets what window.prompt returned for the Pause-account reason: `null` is the Cancel button
// (do nothing), whitespace-only is an empty answer (refuse — the server requires a non-empty reason
// for its audit trail), anything else is the trimmed reason.
export type PauseReasonInput = { kind: "ok"; reason: string } | { kind: "empty" } | { kind: "cancelled" };

export function parsePauseReasonInput(input: string | null): PauseReasonInput {
  if (input === null) return { kind: "cancelled" };
  const reason = input.trim();
  return reason === "" ? { kind: "empty" } : { kind: "ok", reason };
}
